import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import Typography from "@mui/material/Typography";

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import ButtonBase from '@mui/material/ButtonBase';
import IconButton from '@mui/material/IconButton';


import * as Bs4Utils from '../../Bs4Components/Bs4Utils'
import { getBoxSx, getBoxStyle } from '../../Bs4Theme/Bs4UxTemplates';
import { SmallScreenContext, useStateUxTemplate } from '../../Bs4Theme/Bs4UxTemplates';
import { ViewBs4EventDraggable, ORIENTATION_LIST } from './Bs4ReportCalendarViewBs4Event';

import {  
  
  startOfDay, endOfDay,
  startOfWeek, endOfWeek,  
  compareAsc,
  eachHourOfInterval, eachDayOfInterval, eachMonthOfInterval,
  format,
  differenceInMilliseconds,
  roundToNearestMinutes,
  addMilliseconds,
  max, min,
  differenceInMinutes,
  addHours,
  getWeek, getYear,
} from "date-fns";

import {   
  // TYPE_NAVIGATION,
  // TYPE_CALENDAR,
  // TYPE_AGENDE,
  // TYPE_SCHEDULER,
  // TYPE_MODIFIER,

  VIEW_TYPE_YEAR,
  VIEW_TYPE_MONTH,
  VIEW_TYPE_WEEK,
  VIEW_TYPE_DAY,

  // VIEW_TYPE_MODIFIER_LAYER0,
  // VIEW_TYPE_MODIFIER_LAYER1,
  // VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH,

  // borderWidth,
  // borderColor,
} from './Bs4ReportCalendarConst';

import Bs4ReportCalendarView from './Bs4ReportCalendarView'

const HeaderButton = styled(ButtonBase)(({ theme }) => ({ 
  '&:hover, &.Mui-focusVisible': {
    backgroundColor: '#00000007'
  },
}));

export default class Bs4ReportCalendarViewList extends Bs4ReportCalendarView {

  ViewBs4Event = (props) => {
    const theme = useTheme();
    
    const time = React.useMemo(() => {
      if (props.el.bs4Event.AllDay) return <Typography sx={{width: 100, opacity: 0.5,}} variant='subtitle2'>{'Cały dzień'}</Typography>;      
      const startSize = compareAsc(props.el.bs4Event.start, props.el.start) >= 0;
      const endSize = compareAsc(props.el.bs4Event.end, props.el.end) <= 0;
      return (
        <Typography sx={{width: 100, opacity: 0.7,}} variant='subtitle2'>
          <Box component='span' sx={{opacity: startSize ? 1 : 0.5}}>{format(props.el.bs4Event.start, 'HH:mm')}</Box>
          -
          <Box component='span' sx={{opacity: endSize ? 1 : 0.5}}>{format(props.el.bs4Event.end, 'HH:mm')}</Box>
        </Typography>
      )      
    }, [props.el])

    return (            
      <Stack direction="row" sx={{justifyContent: "flex-start", alignItems: "flex-start", marginTop: '4px', marginBottom: '4px'}}>
        {/* <Typography sx={{width: 100, opacity: 0.5,}} variant='subtitle2'>{time}</Typography> */}
        {time}
        <ViewBs4EventDraggable
          orientation={ORIENTATION_LIST}
          el={props.el}
          onRowClick={props.onRowClick}
          tooltipPlacement='left'
          bs4Calendar={props.bs4Calendar}
          noChtime={true}
      />
      </Stack>
    )
  }

  ViewDay = React.memo((props) => {
    const report = this
    const theme = useTheme();
    
    const elArray = React.useMemo(() => {
      return props.day.elArray.sort((elA, elB) => {
        if (elA.bs4Event.AllDay && !elB.bs4Event.AllDay) return -1;
        if (!elA.bs4Event.AllDay && elB.bs4Event.AllDay) return 1;              
        let compare = compareAsc(elA.start, elB.start);
        if (compare !== 0) return compare;
        return compareAsc(elA.bs4Event.end, elB.bs4Event.end);
      });
    }, [props.day.elArray]);

    const opacity =  elArray.length > 0 ? 0.7 : 0.3;

    const handleNavigateToDay = () => {    
      props.onChangeView(props.day.date, VIEW_TYPE_DAY);
    } 

    const handleNavigateToMonth = () => {    
      props.onChangeView(props.day.date, VIEW_TYPE_MONTH);
    }     

    const now = React.useMemo(() => {
      const now = startOfDay(new Date());
      const day = startOfDay(props.day.date);
      return compareAsc(now, day) === 0;
    }, [props.day.date])

    const square = 40;

    return (
      <Box
        display='flex'
        flexDirection={'row'}
        flexWrap={'wrap'}
        borderBottom={'1px solid rgb(0, 0, 0, 0.12)'}
        // borderWidth={'1px'}
      >
        <Box          
          display='flex'
          flexDirection={'row'}
          position='sticky'
          alignSelf='flex-start'
          columnGap='5px'
          top={0}
          zIndex={10}
          width={200}
          backgroundColor={theme.Bs4.backgroundColor}          
        >          
          <IconButton
            onClick={handleNavigateToDay}
            size='small'
            sx={{            
              width: square,
              height: square,     
              pointerEvents: 'auto',       
              zIndex: 10,
              border: now ? '3px dashed #ff000022' : null,
            }}
            >
            <Typography variant='h5' sx={{opacity: opacity}}>{format(props.day.date, 'dd')}</Typography>
          </IconButton>
          <Stack direction="column" spacing={0} sx={{justifyContent: "flex-start", alignItems: "flex-start",}}>       
            <Typography variant='body2' sx={{opacity: opacity}}>{format(props.day.date, 'EEEE')}</Typography>
            <HeaderButton onClick={handleNavigateToMonth}>
              <Typography variant='body2' sx={{opacity: opacity}}>{format(props.day.date, 'LLL yyyy')}</Typography>
            </HeaderButton>
          </Stack>
        </Box>
        <Stack direction='column' sx={{flex:1, minWidth: 300, justifyContent: "flex-start", alignItems: "flex-start"}}>
          {elArray.length > 0 ? elArray.map(el => {
            if (el.bs4Event?.move?.active) return null;
            return (
              <report.ViewBs4Event 
                key={el.bs4Event.key} 
                date={props.day.date} 
                el={el}
                onRowClick={props.onRowClick}
                bs4Calendar={props.bs4Calendar}
              />          
            )}) : 
            <Typography variant='h4' sx={{opacity: opacity}}>{'Brak danych'}</Typography>
            }
        </Stack>
      </Box>
    )
  });

  getEl = (date, bs4Event) => {
    return {
      start: max([startOfDay(date), bs4Event.start]),
      end: min([endOfDay(date), bs4Event.end]),
      bs4Event: bs4Event,
    }    
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    
    const [startPeriod, endPeriod] = React.useMemo(() => {      
      return [props.bs4Calendar.start, props.bs4Calendar.end];
    }, [props.bs4Calendar.start, props.bs4Calendar.end]);

    const dayArray = React.useMemo(() => {
      const days = {};      
      props.bs4Calendar.getVisibleEvents().forEach(bs4Event => {
        if (compareAsc(bs4Event.end, startPeriod) < 0 || compareAsc(bs4Event.start, endPeriod) > 0) return;
        eachDayOfInterval({start: bs4Event.start, end: bs4Event.end}).forEach(date => {
          if (compareAsc(date, startPeriod) < 0 || compareAsc(date, endPeriod) > 0) return;
          const key = format(date, 'Y-D', {useAdditionalDayOfYearTokens: true}); 
          let day = days[key];        
          if (!day) {
            day = {
              date: date,
              elArray: [],
            }            
            days[key] = day;
          }
          day.elArray.push(this.getEl(date, bs4Event));
        })        
      });
      
      let dayArray = Object.values(days);        
      dayArray = dayArray.sort(({date: dateA}, {date: dateB}) => compareAsc(dateA, dateB));
      if (dayArray.length === 0) {
        dayArray.push({
          date: startPeriod,
          end: endPeriod,
          elArray: [],
        });
      }
      return dayArray;      
      
    }, [startPeriod, endPeriod, props.bs4Calendar, props.calendarChangeTime])

    // console.log('...???... view', dayArray.length)
   
    return (      
      <Box
        height='100%'
        display='flex'        
        flexDirection='column'
        overflow='auto'
      >
        {dayArray.map((day) => {
          return (
            <report.ViewDay 
              key={day.date} 
              day={day} 
              calendarChangeTime={props.calendarChangeTime}
              onRowClick={props.onRowClick}
              active={props.active}
              bs4Calendar={props.bs4Calendar}
              onChangeView={props.onChangeView}
            />
          )
        })}
      </Box>
    );
  });
}